/* eslint-disable immutable/no-mutation */

import { EXCLUDED_SUBDOMAINS } from './constants';

const hostname = window.location.hostname.replace('www.', '');

export const getSlug = () => {
  const [subdomain] = hostname.split('.');
  if (EXCLUDED_SUBDOMAINS.includes(subdomain)) return '';
  return subdomain.toLocaleLowerCase();
};

export const updateSlug = (value: string, exchangeCode: string) => {
  const currentSlug = getSlug();
  const newHostname = [
    value.toLocaleLowerCase(),
    currentSlug ? hostname.replace(`${currentSlug}.`, '') : hostname,
  ].join('.');

  const url = new URL(window.location.origin);
  url.hostname = newHostname;
  url.searchParams.set('exchange', exchangeCode);
  window.location.href = url.toString();
};

export const removeSlug = () => {
  const slug = getSlug();
  if (!slug) return;
  const newHostname = hostname.replace(`${slug}.`, '');
  if (newHostname === hostname) return;
  window.location.hostname = newHostname;
};

export const isSlugCorrect = (value: string) => {
  const currentSlug = getSlug();
  if (!currentSlug || currentSlug !== value.toLocaleLowerCase()) return false;
  return true;
};
